<template>
  <v-app class="my-application">
    <!-- content -->
    <v-main>
      <div v-if="loading" style="position: absolute">
        <app-spinner text="Loading..."></app-spinner>
      </div>
      <router-view></router-view>
    </v-main>
    <!-- footer -->
    <v-footer app absolute padless>
      <app-footer></app-footer>
    </v-footer>
    <toast-message
      :title="toastMsg.title"
      :msg="toastMsg.msg"
      :color="toastMsg.color"
    ></toast-message>
  </v-app>
</template>

<script>
import Spinner from './components/Spinner.vue'
import Footer from './components/Footer.vue'
import ToastMessage from './components/ToastMessage.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data() {
    return {}
  },
  created() {
    // table height
    window.addEventListener('resize', this.setWindowsHeight)
    // change table height
    this.setWindowsHeight()
  },
  mounted() {},
  computed: {
    ...mapGetters(['user', 'allUser', 'loading', 'toastMsg']),
  },
  methods: {
    setWindowsHeight() {
      this.$store.commit('setWindowHeight', window.innerHeight)
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWindowsHeight)
  },
  components: {
    AppSpinner: Spinner,
    AppFooter: Footer,
    ToastMessage,
  },
}
</script>

<style scoped></style>

<style>
#app,
.theme--dark.v-toolbar.v-sheet,
.theme--dark.v-card,
.theme--dark.v-data-table {
  background-color: var(--v-background-base) !important;
}
</style>
